import z from "zod/v4";
import { m } from "#/paraglide/messages";

export const loginSchema = z.object({
  email: z.email({ message: m["validation.email_invalid"]() }),
  password: z.string().min(8, { message: m["validation.password.min_length"]() }),
});
